import i18n from 'helper/i18n';
import { compileDynamicRoute } from 'helper/string';
import { PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';

export const getItemURL = (programItemId: string, selectedPool: PoolEnumType) =>
	compileDynamicRoute(i18n('react.impulsCoach.routes.poolDetail.href'), {
		selectedPool: i18n(`react.impulsCoach.routes.pool.selectedPool.${selectedPool}.href`),
		programItemId,
	});
